import SvgIcon from "@mui/material/SvgIcon"

export default function ProfileIcon() {
  return (
    <SvgIcon>
      <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
          <title>Zero State Profile</title>
          <defs>
              <circle id="path-1" cx="24" cy="24" r="24"></circle>
          </defs>
          <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <g id="User/Admin/CS" transform="translate(-18, -18)">
                  <g id="Zero-State-Profile" transform="translate(18, 18)">
                      <mask id="mask-2" fill="white">
                          <use xlinkHref="#path-1"></use>
                      </mask>
                      <use id="Oval" fill="#F0F3F5" xlinkHref="#path-1"></use>
                      <g id="Person" mask="url(#mask-2)" fill="#7FB6D9" fillRule="nonzero">
                          <g transform="translate(6, 12)" id="Combined-Shape">
                              <path d="M18,18 C15.525,18 13.40625,17.11875 11.64375,15.35625 C9.88125,13.59375 9,11.475 9,9 C9,6.525 9.88125,4.40625 11.64375,2.64375 C13.40625,0.88125 15.525,0 18,0 C20.475,0 22.59375,0.88125 24.35625,2.64375 C26.11875,4.40625 27,6.525 27,9 C27,11.475 26.11875,13.59375 24.35625,15.35625 C22.59375,17.11875 20.475,18 18,18 Z M0,36 L0,29.7 C0,28.425 0.3285,27.25275 0.9855,26.18325 C1.641,25.11525 2.5125,24.3 3.6,23.7375 C5.925,22.575 8.2875,21.70275 10.6875,21.12075 C13.0875,20.54025 15.525,20.25 18,20.25 C20.475,20.25 22.9125,20.54025 25.3125,21.12075 C27.7125,21.70275 30.075,22.575 32.4,23.7375 C33.4875,24.3 34.359,25.11525 35.0145,26.18325 C35.6715,27.25275 36,28.425 36,29.7 L36,36 L0,36 Z"></path>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>
    </SvgIcon>
  )
}
